import { Link } from "react-router-dom";
import { AppLogo } from "./AppLogo";

export const AuthHeader = () => {
  return (
    <div className="w-full border-b">
      <div className="mx-auto p-3 px-4 sm:px-6 flex h-[64px] items-center justify-center">
        <div className="flex justify-center">
          <Link className="flex items-center" to="/">
            <AppLogo />
          </Link>
        </div>
      </div>
    </div>
  );
};
